export default "__VITE_ASSET__2a76ce1f__"